import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "index";
var CalismaService = {

    statusGuncelle(status) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                status: status,
                serviceName: "calisma",
                methodName: "statusGuncelle"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    saatBilgileri() {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                serviceName: "calisma",
                methodName: "saatBilgileri"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    mesaiSaati(baslangic1, baslangic2, bitis1, bitis2) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                baslangic1: baslangic1,
                baslangic2: baslangic2,
                bitis1: bitis1,
                bitis2: bitis2,
                serviceName: "calisma",
                methodName: "mesaiSaati"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    statusOku() {
        var param = {
            data: {
                serviceName: "calisma",
                methodName: "statusOku"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

};
export default CalismaService
